import React from "react";

import Link from "next/link";
import { useSearchParam } from "react-use";
import styled from "styled-components";

import VaspBackButton from "./components/VaspBackButton";
import VaspNavigationButtons from "./components/VaspNavigationButtons";
import { Container, Header, Content, SunriseInfo, UserBox, SunriseInfoBold, HeaderContainer, VASPInfo } from "./styles";
import VaspInfoSections from "./VaspInfoSections";

import { Buttons, ButtonLink } from "~/components/Button";
import { PaddingResponsive } from "~/components/Elements";
import * as Grid from "~/components/Grid";
import Skeleton from "~/components/Skeleton";
import Spacer, { Axis } from "~/components/Spacer";
import useSession from "~/hooks/use-session";
import VASPBlockchainActivity from "~/templates/companies/components/VASPBlockchainActivity";
import VASPHeader from "~/templates/companies/components/VASPHeader";
import NonAuthenticatedUserBox from "~/templates/network/components/NonAuthenticatedUserBox";
import { VASP } from "~/types/vaspid";

interface Props {
  vasp: VASP | undefined;
  nextVaspURL: string;
  previousVaspURL: string;
}

const Div = styled.div`
  width: 100%;
`;

export default function VaspPublicInfo({ vasp, nextVaspURL, previousVaspURL }: Props) {
  const { data: session } = useSession();
  const viewer = session?.viewer;

  const flagNextFromQyert = useSearchParam("next");
  const flagNext = Boolean(Number(flagNextFromQyert));

  return (
    <Container>
      <Header>
        <PaddingResponsive as={Div}>
          <VaspBackButton vasp={vasp} />

          <HeaderContainer>
            <VASPHeader vasp={vasp} />
            <Buttons sized="small" marginless align="right">
              {!vasp && (
                <ButtonLink color="success" as="a">
                  <Skeleton />
                </ButtonLink>
              )}
              {vasp && !vasp.hasAdmin && !viewer && (
                <Link href={`/auth?website=${encodeURIComponent(vasp.website || "")}`} passHref>
                  <ButtonLink transform="uppercase" color="success" as="a">
                    Is this your company?
                  </ButtonLink>
                </Link>
              )}
            </Buttons>
          </HeaderContainer>
        </PaddingResponsive>
      </Header>
      <Content>
        <VASPInfo>
          <VaspInfoSections vasp={vasp} showMetabaseDashboard={false} />

          <Spacer axis={Axis.VERTICAL} size={24} />
          {nextVaspURL && previousVaspURL && (
            <VaspNavigationButtons nextVaspURL={nextVaspURL} previousVaspURL={previousVaspURL} />
          )}

          {flagNext && (
            <Grid.Column mobile={12}>
              <VASPBlockchainActivity vasp={vasp} />
            </Grid.Column>
          )}
        </VASPInfo>
        {vasp && (
          <UserBox>
            <NonAuthenticatedUserBox did={vasp.did} vaspName={vasp.name as string} />
            <SunriseInfo>
              The free Sunrise plan includes unlimited incoming and limited to $10,000.00/month outgoing Travel Rule
              data transfers.
            </SunriseInfo>
            <SunriseInfoBold href="https://notabene.id/sunrise" target="_blank" rel="noreferrer">
              Learn more
            </SunriseInfoBold>
          </UserBox>
        )}
      </Content>
    </Container>
  );
}
